import Section from '~/components/flp/Section';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { HeroBackground, HeroContentWrapper, HeroSection } from './Hero.styles';
import HeroContent from './HeroContent';

export default function Hero() {
  return (
    <Section
      as={HeroSection}
      eventName={ANALYTICS_EVENTS.MARKETING.SECTION_VIEWED_HERO}
    >
      <HeroBackground />
      <HeroContentWrapper>
        <HeroContent />
      </HeroContentWrapper>
    </Section>
  );
}
